import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Input } from "reactstrap";
import { Search } from "react-feather";
//IMG
import FilterBottomSheets from "views/ilearn/components/FilterBottomSheets";
import { ChevronLeft } from "react-feather";
import bookmark from "views/job-listing/img/bookmark.svg";
import logo from "views/ilearn/img/icici.png";
import filter from "views/job-listing/img/filter.png";
import TrendingJobs1 from "views/home/img/courses/course1.png";
class IlearnCourses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
      filter: false,
    };
    this.bottomSheet = React.createRef();
  }
  addDefaultSrc(ev) {
    ev.target.src = TrendingJobs1;
  }
  handleFilter() {
    if (window.innerWidth > 575) {
      this.setState({ filter: !this.state.filter });
    } else {
      this.bottomSheet.current.toggleBottomSheet();
    }
  }
  render() {
    return (
      <div>
        <FilterBottomSheets ref={this.bottomSheet} />
        <div className="  pb-8 lg:pt-16 md:pt-16 pt-0 lg:px-0 md:px-0 px-4 lg:mt-0 md:mt-0 mt-4">
          <div className="button-section flex sm-reverse-btn">
            <button
              className="filter-btn flex justify-center items-center font-semibold fsize16 md:mr-8 lg:mr-8"
              onClick={() => this.handleFilter()}
            >
              <p className="mr-3">FILTERS</p>
              <img src={filter} alt="filter" />
            </button>

            <h2 className="fsize28 font-bold uppercase text-black sm-fsize16">
              All Courses
            </h2>
          </div>

          <div className="mt-10 flex">
            {this.state.filter && (
              <div className="filter lg:w-1/4 md:w-1/4 w-3/5 pr-6">
                <card className="rounded-12px drop-shadow20px block p-6 ">
                  <div className="flex justify-between">
                    <h1 className="fsize18 text262626 font-semibold">
                      Filters
                    </h1>
                    <p className="fsize16 textE77817 underline  ">Clear all</p>
                  </div>

                  <div className="relative  mt-6 mb-8">
                    <Search
                      width="18"
                      height="18"
                      className="absolute filter-searchicon"
                    />
                    <Input
                      type="text"
                      name="search"
                      className="w-full cust-shadow-md py-3 pl-12 pr-4 text#4B4B4B opacity-60per fsize14 rounded-full "
                      placeholder="Search..."
                    />
                  </div>

                  <div className="mb-6">
                    <h1 className="fsize16 text262626 font-semibold">
                      Course Provider
                    </h1>
                    <div className="mt-4">
                      <div className="flex justify-between mb-1">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              ICICI
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          16
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Universal
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* category */}
                  <div className="mb-6">
                    <h1 className="fsize16 text262626 font-semibold">
                      Duration
                    </h1>
                    <div className="mt-4">
                      <div className="flex justify-between mb-1">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 flex items-center fsize14 opacity-80per">
                              <ChevronLeft width="18px" height="18px" /> 5 Hours
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          16
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 flex items-center fsize14 opacity-80per ">
                              <ChevronLeft width="18px" height="18px" /> 4 Weeks
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              5+ Weeks
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* experience */}
                  <div className="mb-6">
                    <h1 className="fsize16 text262626 font-semibold">
                      Start Date
                    </h1>
                    <div className="mt-4">
                      <div className="flex justify-between mb-1">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              This Week
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          16
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              This Month
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              From Next Month
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          0
                        </p>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
            )}

            <div
              className={`all-jobscard lg:gap-6 md:gap-6 gap-4 grid  ${
                this.state.filter
                  ? "lg:w-3/4 md:w-3/4 w-2/5 lg:grid-cols-3 md:grid-cols-3 grid-cols-1"
                  : "w-full lg:grid-cols-4 md:grid-cols-4 grid-cols-2"
              }`}
            >
              {this.props.courses.map((val, index) => {
                return (
                  <card
                    className="rounded-12px drop-shadow block coursor-pointer h-fitcontent"
                    onClick={() =>
                      this.props.history.push(
                        `${process.env.PUBLIC_URL}/Career/ilearn-details/${val.c_courseId}`
                      )
                    }
                    key={index}
                  >
                    <div className="relative">
                      <img
                        onError={this.addDefaultSrc}
                        src={`http://localhost:3001/${val.c_path}`}
                        alt="jobs"
                        className="w-full maxh-121px"
                      />
                      <div className="absolute bookmark-parent text-white rounded-full">
                        <img
                          src={bookmark}
                          alt="jobs"
                          className="bookmark-t-c"
                        />
                      </div>
                    </div>

                    <div className="lg:p-6 md:p-6 p-4 relative">
                      <div className="absolute -top-30 bg-white rounded-8px p-8px ">
                        <img src={logo} alt="icon" className="w-50px h-50px" />
                      </div>

                      <h1 className="fsize18 font-bold mt-4 mob-fsize14">
                        {val.c_title || "The Course"}
                      </h1>
                      <p className="line-clamp-2 fsize12 text-black opacity-60 pt-1">
                        {val.c_short_description || "this is short description"}
                      </p>

                      <p className="dashed-border-b lg:mt-4 md:mt-4 mt-2"></p>
                      <div className="flex justify-start items-center lg:mt-4 md:mt-4 mt-2">
                        <div className="flex items-center mr-2">
                          <p className="text-black opacity-50  fsize12">
                            {`${val.c_short_description}`.split("|")[1] ||
                              "6 Courses(12h)"}
                          </p>
                        </div>
                        <div className="flex items-center">
                          <span className="dot-point bg-bluecolor rounded-full mx-2"></span>
                          <p className="text-black opacity-50 fsize12">
                            Starts {val.start_date || "Now"}
                          </p>
                        </div>
                      </div>
                      <div className="mt-4 flex items-start mob-hidden">
                        <p className="underline fsize14 text-orange-c ">
                          View Details
                        </p>
                      </div>
                    </div>
                  </card>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(IlearnCourses);
